import { Component, OnInit } from '@angular/core'
import { ValidityService } from './validity.service'
import { ValidityModel } from './validity.model'
import { ToastrModule, ToastrService } from 'ngx-toastr'
import { ReactiveFormsModule } from '@angular/forms'
import { CommonModule } from '@angular/common'
import { MatDialog, MatDialogModule } from '@angular/material/dialog'
import { ConfirmationDialogComponent } from '../../../shared/components/confirmation-dialog/confirmation-dialog.component'
import { DatatableComponent } from '../../../shared/components/master-datatable/master-datatable.component'
import { MasterAddUpdateDialogComponent } from '../../../shared/components/master-add-update-dialog/master-add-update-dialog.component'
import { MasterDatabaseDisplayModel } from '../../../shared/master-database-display.model'
import { MasterCommonServices } from '../../quotation/master.common.service'

@Component({
  selector: 'app-validity.master',
  standalone: true,
  imports: [
    ToastrModule,
    ReactiveFormsModule,
    CommonModule,
    DatatableComponent,
  ],
  templateUrl: './validity.master.component.html',
  styleUrl: './validity.master.component.css',
})
export class ValidityMasterComponent {
  validityColumns: MasterDatabaseDisplayModel[] = [
    {
      key: 'validity',
      displayName: 'Validity Name',
      hiddenDataTable: false,
      hiddenDialog: false,
      type: 'text',
    },
    {
      key: 'addedOn',
      displayName: 'Added Date',
      hiddenDataTable: false,
      hiddenDialog: true,
      type: 'date',
    },
    {
      key: 'id',
      displayName: 'Id',
      hiddenDataTable: true,
      hiddenDialog: true,
      type: 'text',
    },
  ]
  isLoading: boolean = false

  constructor(
    private validityService: ValidityService,
    private toastr: ToastrService,
    private dialog: MatDialog,
    public masterCommonService: MasterCommonServices,
  ) {}

  ngOnInit(): void {}

  openAddUpdateValidityDialog(mode: string, validity?: ValidityModel): void {
    const fields = this.validityColumns
    const dialogRef = this.dialog.open(MasterAddUpdateDialogComponent, {
      data: { item: validity || {}, mode, fields },
    })

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        if (mode === 'update') {
          this.updateValidity(result)
        } else {
          this.addValidity(result)
        }
      }
    })
  }

  addValidity(validity: any): void {
    this.validityService.addValidity(validity).subscribe({
      next: () => {
        this.toastr.success('Validity Added Successfully!', 'Success')
        this.masterCommonService.getAllValidities()
      },
      error: (error: any) => {
        this.toastr.error(error.statusText, 'Error', { timeOut: 15000,
  closeButton: true,
  progressBar: true, })
      },
    })
  }

  updateValidity(validity: any): void {
    this.validityService.updateValidity(validity).subscribe({
      next: () => {
        this.toastr.success('Validity Updated Successfully!', 'Success')
        this.masterCommonService.getAllValidities()
      },
      error: (error: any) => {
        this.toastr.error(error.statusText, 'Error', { timeOut: 15000,
  closeButton: true,
  progressBar: true, })
      },
    })
  }

  deleteValidity(validity: ValidityModel): void {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: { message: 'Are you sure you want to delete this validity?' },
    })
    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        validity.isDeleted = true
        this.validityService.deleteValidity(validity).subscribe({
          next: () => {
            this.masterCommonService.validitiesList = this.masterCommonService.validitiesList.filter(
              (p) => p.id !== validity.id,
            )
            this.toastr.success('Validity Deleted Successfully!', 'Success')
          },
          error: (error: any) => {
            this.toastr.error(error.statusText, 'Error', { timeOut: 15000,
  closeButton: true,
  progressBar: true, })
          },
        })
      }
    })
  }
}
